import posthog from "posthog-js"
import { browser, dev } from "$app/environment"

export const load = async ({ data }) => {
  if (browser && !dev) {
    posthog.init(
      'phc_thMfefSYE735uO1Zry6eQpbPlH6lYecWj7QbsnGbijV',
      { 
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'always',
      }
    )

    if (data?.id) {
      posthog.identify(data.id, {
        email: data.email,
        id: data.id,

      })
    }
  }

  return
};